module.exports = __webpack_public_path__ + "img/IMG-20200609-WA0087.6df6d122.jpg";